import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import "element-ui/lib/theme-chalk/index.css"
import request from "./axios";
import globalFun from './globalFun'

// require("./mock") //引入mock数据，关闭则注释该行

Vue.use(Element)

Vue.config.productionTip = false
Vue.prototype.$axios = request

var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?d83c6c0ae633f8eb585ebb8a1d676f09";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
